import { createContext, useState } from 'react'
import { WithChildren } from '_metronic/helpers'

interface IContext {
  isOpenImportModal: boolean
  setIsOpenImportModal: (isOpen: boolean) => void
  isOpenViewModal: boolean
  setIsOpenViewModal: (isOpen: boolean) => void
  isOpenImageUploaderModal: boolean
  setIsOpenImageUploaderModal: (isOpen: boolean) => void
}

export const SurveyViewContext = createContext<IContext>({
  isOpenImportModal: false,
  setIsOpenImportModal: () => {},
  isOpenViewModal: false,
  setIsOpenViewModal: () => {},
  isOpenImageUploaderModal: false,
  setIsOpenImageUploaderModal: () => {},
})

export const SurveyViewContextProvider: React.FC<WithChildren> = ({ children }) => {
  const [isOpenImportModal, setIsOpenImportModal] = useState(false)
  const [isOpenViewModal, setIsOpenViewModal] = useState(false)
  const [isOpenImageUploaderModal, setIsOpenImageUploaderModal] = useState(false)

  return (
    <SurveyViewContext.Provider
      value={{
        isOpenImportModal,
        setIsOpenImportModal,
        isOpenViewModal,
        setIsOpenViewModal,
        isOpenImageUploaderModal,
        setIsOpenImageUploaderModal,
      }}>
      {children}
    </SurveyViewContext.Provider>
  )
}
